import { Button, Form } from "antd";
import { HiOutlineMinusCircle } from "react-icons/hi2";
import { DateFormat, Rules } from "../../../../../../constants";
import { DatePicker } from "../../../../../../components";
import { checkValidDates } from "../create-application-for-leave-form";

interface Props {
  ePaidLeaveRemain?: number;
  disabled?: boolean;
}

const VacationPeriodList = ({ ePaidLeaveRemain, disabled }: Props) => {
  return (
    <Form.List name="eVacationPeriods">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field) => (
            <Form.Item required={false} key={field.key}>
              <Form.Item
                {...field}
                rules={[
                  Rules.required("Vui lòng chọn trường này!"),
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const a = getFieldValue("eVacationPeriods");
                      if (ePaidLeaveRemain === undefined || !value) {
                        return Promise.resolve();
                      }
                      const isValid = checkValidDates(a, ePaidLeaveRemain);
                      if (isValid) return Promise.resolve();
                      return Promise.reject(new Error("Vượt quá số ngày phép"));
                    },
                  }),
                ]}
                noStyle
              >
                <DatePicker.RangePicker
                  disabled={disabled}
                  showTime={{ format: "HH:mm" }}
                  format={DateFormat.DD_MM_YYYY_HH_MM}
                />
              </Form.Item>
              {fields.length > 1 ? (
                <HiOutlineMinusCircle style={{ fontSize: 22, marginLeft: 10 }} onClick={() => remove(field.name)} />
              ) : null}
            </Form.Item>
          ))}
          <Form.Item>
            <Button disabled={disabled} size="middle" type="dashed" onClick={() => add()} block>
              Thêm thời gian nghỉ
            </Button>
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

export default VacationPeriodList;
